<template>
	<a @click.prevent="handleClick">
		<slot />
	</a>
</template>

<script>
export default {
	props: {
		scrollTarget: {
			type: String,
			required: true,
		},
	},
	methods: {
		handleClick() {
			const { top } = document.getElementById( this.scrollTarget ).getBoundingClientRect();
			const scrollTop = top + window.scrollY;
			window.scrollTo( {
				top: scrollTop,
				left: 0,
				behavior: 'smooth',
			} );
			// Update URL in address bar
			history.pushState( null, null, `#${ this.scrollTarget }` );
		},
	},
};
</script>
